import React, { useState } from "react";
import { DescriptionEditIcon, WorkflowItemDeleteIcon } from "../common/Icon";

const DailyPlaining = () => {
  const [dailyPlanningData, setDailyPlanningData] = useState([
    { name: "Commodo purus facilisis", done: true },
    { name: "Commodo purus facilisis", done: true },
    { name: "Commodo purus facilisis", done: true },
    { name: "Commodo purus facilisis", done: true },
  ]);
  const [clickedIndexes, setClickedIndexes] = useState([]);
  const addNewTask = () => {
    const newTask = { name: "Commodo purus facilisis", done: true };
    setDailyPlanningData([...dailyPlanningData, newTask]);
  };

  const deleteTask = (index) => {
    const updatedData = [...dailyPlanningData];
    updatedData.splice(index, 1);
    setDailyPlanningData(updatedData);
    setClickedIndexes("");
  };
  const toggleTask = (index) => {
    if (clickedIndexes.includes(index)) {
      setClickedIndexes(clickedIndexes.filter((i) => i !== index));
    } else {
      setClickedIndexes([...clickedIndexes, index]);
    }
  };

  return (
    <div className="rounded-xl px-4 lg:pl-[22px] lg:pr-[18px] pt-[26px] pb-[20px] bg-white shadow-workflow_item_card_shadow md:ml-4 md:h-[calc(100vh-340px)] lg:h-[calc(100vh-320px)] xl:h-[calc(100vh-317px)] 2xl:h-[calc(100vh-300px)] mb-4  ">
      <h4 className="text-black font-bold text-sm 3xl:text-[16px]">
        Set daily planning
      </h4>
      <p className="text-black font-normal text-xs 3xl:text-[14px] pt-1">
        Let's get started with your Today's Productivity
      </p>
      <div className="pt-4">
        <div className="overflow-y-auto overflow_x_scroll_style h-[calc(100vh-550px)]  md:h-[calc(100vh-530px)] lg:h-[calc(100vh-520px)] xl:h-[calc(100vh-570px)] 2xl:h-[calc(100vh-550px)]">
          {dailyPlanningData.map((task, index) => (
            <div
              key={index}
              className="text-black mr-2 text-xs font-semibold flex items-end justify-between  mt-3 rounded-[10px] todo_bg_color">
              <div
                className="flex items-center p-2 lg:p-5 plaining_input cursor-pointer"
                onClick={() => {
                  toggleTask(index);
                }}>
                <input
                  className="line-through mr-3 h-[20px] w-[20px] border  border-primary"
                  type="checkbox"
                  checked={clickedIndexes.includes(index) ? task.done : ""}
                />
                <span
                  className={`font-semibold text-xs 3xl:text-[14px] ${
                    clickedIndexes.includes(index) ? "line-through" : ""
                  }`}>
                  {task.name}
                </span>
              </div>
              <div className="gap-2 flex pr-[6px] pb-[6px]">
                <button
                  className={` ${
                    clickedIndexes.includes(index) ? "hidden" : "block"
                  }`}>
                  <DescriptionEditIcon />
                </button>
                <button onClick={() => deleteTask(index)}>
                  <WorkflowItemDeleteIcon />
                </button>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center pt-5 lg:pt-10 xl:pt-[88px]">
          <button
            onClick={addNewTask}
            className="bg-primary text-white text-sm border border-solid border-transparent font-medium px-7 py-3 rounded-[36px] hover:bg-transparent hover:text-primary hover:border-primary duration-200 ">
            + Add a New Task
          </button>
        </div>
      </div>
    </div>
  );
};

export default DailyPlaining;
